import { emitRecoAddToCartButtonLabelEvent } from "./eventEmitter";

const track = () => {
    emitRecoAddToCartButtonLabelEvent({ promo_RecoAddToCartButton: "visible" });
};

export default track;
